// SUPER ADMIN EDIT GEREKCESI — istemci tarafi boru hatti (11 Agu 2026)
// Mimari kural: CLAUDE.md TASARIM ILKELERI md.6
//
// Serkan: "Her yerde yazabilir, ne yazarsa yazsin, ama editini RAPOR ILE
// gerceklestirebilir — aksi halde olmaz. Yaptigi edit ilgili sirketin log
// kayitlarinda tutulur."
//
// NASIL CALISIR: gerekce, yazma ISTEGININ BASLIGIYLA gider (x-edit-reason).
// Veritabanindaki tetikleyici onu okur; yoksa yazmayi REDDEDER ve iz de yazmaz.
// Yani kural ekranin iyi niyetine degil, veritabanina baglidir.
//
// NEDEN AYRI ISTEMCI: supabase-js tek tek cagrilara baslik eklemeye izin
// vermiyor; gerekceyi tasiyan kisa omurlu bir istemci uretip onunla yaziyoruz.
//
// UNUTULAN KAPI SESSIZ KALMAZ: gerekcesiz yazan bir yol kalirsa veritabani
// 42501 ile reddeder, kullanici hatayi GORUR. 10 Agu'daki yarim silmenin
// (catch {} ile yutulan hata) tam tersi.

import { createClient } from '@supabase/supabase-js';
import { supabase } from './supabaseClient';
import { gerekceTamam, gerekceIpucuMetni } from './components/gerekceKurali';   // ortak gerekçe kuralı (21 Eki 2026, K7)

const URL = process.env.REACT_APP_SUPABASE_URL;
const ANON = process.env.REACT_APP_SUPABASE_ANON_KEY;

/**
 * Gerekceyi tasiyan gecici istemci dondurur.
 * @param {string} reason  Zorunlu. Bos/kisa ise cagri yapilmadan hata verilir.
 */
export async function withReason(reason) {
  const r = String(reason || '').trim();
  // Ortak kural (21 Eki 2026, K7): en az 3 karakter — pencere ve formlarla aynı.
  if (!gerekceTamam(r)) throw new Error(gerekceIpucuMetni(r));

  const { data: { session } } = await supabase.auth.getSession();
  if (!session) throw new Error('Session expired, please log in again.');

  const istemci = createClient(URL, ANON, {
    auth: { persistSession: false, autoRefreshToken: false },
    global: {
      headers: {
        Authorization: `Bearer ${session.access_token}`,
        'x-edit-reason': r,
      },
    },
  });
  // Gerekçe metni de istemciyle gelir (2 Eki 2026): kendi `reason` sütunu olan tablolar (motor tabanları)
  // AYNI metni yazar — ikinci kez sorulmaz, iki ayrı gerekçe doğmaz.
  istemci.gerekce = r;
  return istemci;
}

/**
 * Gerekceyi SORAR ve yazmaya hazir istemciyi dondurur; iptal edilirse null.
 * Cagri sekli:  const sb = await askReason(); if (!sb) return;
 * Sonra o handler icindeki YAZMA cagrilarinda `supabase` yerine `sb` kullanilir.
 * (Okumalar normal `supabase` ile kalir — kural yalnizca yazmayi ilgilendirir.)
 */
// Gerekce kutusunu ACAN bilesen kendini buraya kaydeder (AdminPanel icindeki
// EditReasonGate). Boylece cagri yerleri degismeden kaliyor: `await askReason()`
// hem modal'la hem de (kayit yoksa) tarayici kutusuyla calisir.
let _opener = null;
export function setReasonOpener(fn) { _opener = fn; }

export async function askReason(what = 'this change') {
  const r = _opener
    ? await _opener(what)                       // kendi tasarimimiz (cok satirli hucre)
    : window.prompt(`Reason for ${what}:`, ''); // yedek yol
  if (r === null || r === undefined) return null;
  try {
    return await withReason(r);
  } catch (e) {
    alert(e.message);
    return null;
  }
}
